<template>
	<div>
		<router-view />
	</div>
</template>

<script>
	export default{
		name:"InTk",
		data(){
			return{
				
			}
		}
	}
</script>

<style>
</style>

